import './ArrowIcon.css';

export function ArrowIcon (props) {
    return (
        <svg {...props}  width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 5L8 0H0L4 5Z"/>
        </svg>
    )
}